import { AppRoutes } from 'src/lib/routes';
import { NextSeo } from 'next-seo';
import WithDefaultJsonLd from 'src/components/WithDefaultJsonLd';
import ImageWithFallback from 'src/components/ImageWithFallback';
import WildlifeSafeImage from 'public/images/our_mission/wildlife_safe.png';
import WildlifeSafe1Image from 'public/images/our_mission/wildlife_safe_1.png';
import WildlifeSafe2Image from 'public/images/our_mission/wildlife_safe_2.png';
import LeaveNoTraceImage from 'public/images/our_mission/leave_no_trace.png';
import LeaveNoTrace1Image from 'public/images/our_mission/leave_no_trace_1.png';
import LeaveNoTrace2Image from 'public/images/our_mission/leave_no_trace_2.png';
import LowCarbonImage from 'public/images/our_mission/low_carbon.png';
import LowCarbon1Image from 'public/images/our_mission/low_carbon_1.png';
import LowCarbon2Image from 'public/images/our_mission/low_carbon_2.png';
import RefusePlasticsImage from 'public/images/our_mission/refuse_plastics.png';
import RefusePlastics1Image from 'public/images/our_mission/refuse_plastics_1.png';
import RefusePlastics2Image from 'public/images/our_mission/refuse_plastics_2.png';
import CommunityBasedImage from 'public/images/our_mission/community_based.png';
import CommunityBased1Image from 'public/images/our_mission/community_based_1.png';
import CommunityBased2Image from 'public/images/our_mission/community_based_2.png';
import WomenOwnedImage from 'public/images/our_mission/women_owned.png';
import WomenOwned1Image from 'public/images/our_mission/women_owned_1.png';
import WomenOwned2Image from 'public/images/our_mission/women_owned_2.png';
import ElephantImage from 'public/images/our_mission/elephant.png';
import TreeImage from 'public/images/our_mission/tree.png';
import Tree1Image from 'public/images/our_mission/tree_1.png';
import Tree2Image from 'public/images/our_mission/tree_2.png';
import ButterflyImage from 'public/images/our_mission/butterfly.png';
import Butterfly1Image from 'public/images/our_mission/butterfly_1.png';
import Butterfly2Image from 'public/images/our_mission/butterfly_2.png';
import Butterfly3Image from 'public/images/our_mission/butterfly_3.png';
import GrassImage from 'public/images/our_mission/grass.png';
import Grass1Image from 'public/images/our_mission/grass_1.png';
import PlasticImage from 'public/images/our_mission/plastic.png';
import Plastic1Image from 'public/images/our_mission/plastic_1.png';
import Plastic2Image from 'public/images/our_mission/plastic_2.png';
import CloudImage from 'public/images/our_mission/cloud.png';
import MountainImage from 'public/images/our_mission/mountain.png';
import Mountain1Image from 'public/images/our_mission/mountain_1.png';
import BirdImage from 'public/images/our_mission/bird.png';
import CafeImage from 'public/images/our_mission/cafe.png';
import SustainabilityImage from 'public/images/about/our-sustainability.png';
import BadgeEfftectImage from 'public/images/about/badge_effect.png';
import Badge1Image from 'public/images/our_mission/badge_shadow_1.png';
import Badge2Image from 'public/images/our_mission/badge_shadow_2.png';
import Badge3Image from 'public/images/our_mission/badge_shadow_3.png';
import Badge4Image from 'public/images/our_mission/badge_shadow_4.png';
import Badge5Image from 'public/images/our_mission/badge_shadow_5.png';
import Badge6Image from 'public/images/our_mission/badge_shadow_6.png';
import { FiX } from 'react-icons/fi';
import Link from 'next/link';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import styles from 'src/styles/modules/pages/brand.module.scss';
import { badgeKinds } from 'src/lib/constants';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Overlay } from 'react-bootstrap';
import ClientOnlyPortal from 'src/components/ClientOnlyPortal';
const metaTitle = 'Travel as a Force for Good';
const metaDesc =
  'Seek Sophie is founded by travellers, for travellers. A travel platform that makes adventurous trips super simple to book, based on your travel preferences';

export async function getStaticProps() {
  return {
    props: {},
  };
}

const BadgeTipDescription: React.FC<{ badgeName: string | undefined }> = ({ badgeName }) => {
  return (
    <div className="tw-bg-brand-green tw-p-6 tw-rounded-lg tw-text-center">
      {badgeName === badgeKinds.wildlifeSafe ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Wildlife Protectors
          </div>
          <div>
            By choosing Wildlife Protectors, you{"'"}re not just seeing amazing animals, you
            {"'"}re helping to keep them safe and wild.
          </div>
        </>
      ) : badgeName === badgeKinds.litterFreeLeaveNoTrace ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Leave No Trace Stewards
          </div>
          <div>
            When you support Leave No Trace Stewards, you{"'"}re helping to keep our wild places
            beautiful for everyone to enjoy, now and in the future.
          </div>
        </>
      ) : badgeName === badgeKinds.lowCarbon ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Low Carbon Hero
          </div>
          <div>
            By choosing a Low Carbon Hero, you{"'"}re not just having a great trip, you{"'"}
            re helping to create a more sustainable future for everyone.
          </div>
        </>
      ) : badgeName === badgeKinds.refusePlastics ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Plastic Waste Warriors
          </div>
          <div>
            By choosing Plastic Waste Warriors, you{"'"}re helping to protect our planet from
            plastic pollution. It{"'"}s a small step, but it makes a big difference!
          </div>
        </>
      ) : badgeName === badgeKinds.communityBased ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Community Champion
          </div>
          <div>
            When you choose a Community Champion, you{"'"}re not just getting a great experience,
            you{"'"}re becoming part of something bigger; directly contributing to the well-being of
            the community and helping to create a brighter future for everyone.
          </div>
        </>
      ) : badgeName === badgeKinds.womenOwned ? (
        <>
          <div className="tw-text-xl tw-font-styleSans tw-font-semibold tw-mb-2">
            Women-led Wonder
          </div>
          <div>
            By choosing a Women-led Wonder, you{"'"}re empowering women, promoting equality, and
            helping to create a brighter future for everyone.
          </div>
        </>
      ) : null}
    </div>
  );
};

const StoryPopup: React.FC<{
  badgeName: string | undefined;
  isShow: boolean;
  onClose: () => void;
}> = ({ badgeName, isShow, onClose }) => {
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isShow) {
      if (popupRef.current) {
        disableBodyScroll(popupRef.current);
      }
    } else {
      if (popupRef.current) {
        enableBodyScroll(popupRef.current);
      }
    }
  }, [isShow]);

  return (
    <div>
      <div
        className={classNames('tw-fixed tw-top-0 tw-right-0 tw-w-full tw-z-1200 tw-h-full', {
          'tw-hidden': !isShow,
        })}
      >
        <div
          ref={popupRef}
          className="tw-bg-brand-green md:tw-px-4 tw-px-5 tw-flex tw-overflow-y-auto custom-scrollbar tw-justify-between tw-pb-8 tw-flex-col tw-h-full"
        >
          <div>
            <div className="tw-pt-4 tw-text-center tw-relative">
              <div
                className="tw-absolute tw-right-0 tw-cursor-pointer"
                onClick={() => {
                  typeof onClose === 'function' && onClose();
                }}
              >
                <FiX size={25} className="tw-text-brand-navy" />
              </div>
            </div>
            {badgeName === badgeKinds.wildlifeSafe ? (
              <div className="container md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">WILDLIFE PROTECTORS</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Burm & Emily
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-px-10 tw-px-0">
                  <div className="md:tw-mb-0 tw-mb-4">
                    <div className="tw-relative tw-mb-11">
                      <ImageWithFallback
                        src={WildlifeSafe1Image}
                        alt=""
                        className={styles.missionStoryFirstImage}
                      />
                      <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-12 md:tw--left-6 tw--top-10 tw--left-3">
                        <ImageWithFallback
                          src={Badge1Image}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-absolute tw-top-12 tw--right-6 tw-w-18 tw-h-10 md:tw-hidden tw-block">
                        <ImageWithFallback
                          src={CloudImage}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-absolute tw-w-36 tw-h-12 md:tw-hidden tw-block tw--bottom-7 tw-left-14">
                        <ImageWithFallback
                          src={GrassImage}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                    </div>
                    <div className="md:tw-flex tw-justify-center tw-hidden">
                      <div className="tw-relative">
                        <ImageWithFallback
                          src={WildlifeSafe2Image}
                          alt=""
                          className={styles.missionStorySecondImage}
                        />
                        <div className="tw-absolute tw--bottom-4 tw--left-24 tw-w-36 tw-h-40">
                          <ImageWithFallback
                            src={ElephantImage}
                            fill
                            alt=""
                            className="tw-w-full tw-h-full"
                          />
                        </div>
                        <div className="tw-absolute tw--bottom-14 tw-left-5 tw-w-24 tw-h-36">
                          <ImageWithFallback
                            src={TreeImage}
                            fill
                            alt=""
                            className="tw-w-full tw-h-full"
                          />
                        </div>
                        <div className="tw-absolute tw--top-7 tw-right-2 tw-w-24 tw-h-14">
                          <ImageWithFallback
                            src={CloudImage}
                            fill
                            alt=""
                            className="tw-w-full tw-h-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:tw-mb-0 tw-mb-4">
                    <div className="tw-relative md:tw-pl-10 tw-pl-0">
                      <div className="tw-my-8 md:tw-w-96 tw-w-full">
                        Many of us have seen wildlife be abused in the name of tourism, and have
                        wanted to make things better. Emily first travelled to Thailand as a teen in
                        early 2009 where she experienced first-hand the appalling living conditions
                        and hardships elephants experienced working in tourist camps.
                      </div>
                      <div className="tw-relative">
                        <div className="tw-mb-8 tw-max-w-sm">
                          Emily made a promise to the elephants – she would personally do something
                          about their plight. At 18, Emily and her partner Burm, founded one of
                          Thailand
                          {"'"}s first no-touch, no-bathe sanctuaries. Their sanctuary is one of the
                          few truly ethical sanctuaries in Thailand, where elephants are free to be
                          their wildest selves, not there for tourists{"'"} pleasure.
                        </div>
                        <div className="md:tw-hidden tw-block tw-mb-8">
                          <ImageWithFallback
                            src={WildlifeSafe2Image}
                            alt=""
                            className={styles.missionStorySecondImage}
                          />
                          <div className="tw-absolute tw--bottom-7 tw--left-4 tw-w-24 tw-h-28">
                            <ImageWithFallback
                              src={ElephantImage}
                              fill
                              alt=""
                              className="tw-w-full tw-h-full"
                            />
                          </div>
                          <div className="tw-absolute tw--bottom-8 tw-left-14 tw-w-15 tw-h-24">
                            <ImageWithFallback
                              src={TreeImage}
                              fill
                              alt=""
                              className="tw-w-full tw-h-full"
                            />
                          </div>
                        </div>
                        <div className="tw-absolute md:tw--top-18 md:tw--right-14 tw-top-60 tw--right-8 md:tw-w-20 md:tw-h-18 tw-w-14 tw-h-11">
                          <ImageWithFallback
                            src={ButterflyImage}
                            fill
                            alt=""
                            className="tw-w-full tw-h-full"
                          />
                        </div>
                      </div>
                      <div className="tw-absolute tw--bottom-6 tw--right-24 tw-top-auto tw-w-40 tw-h-14 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={GrassImage}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>

                      <div className="tw-my-8 md:tw-w-96 tw-w-full">
                        They are changing the conversation around wildlife tourism in Thailand,
                        showing by example how to truly respect wildlife. By joining Emily{"'"}s
                        experience, you help stop the abuse of wildlife and pioneer a new form of
                        wildlife tourism that respects and does not exploit animals.
                      </div>
                      <div className="md:tw-text-left tw-text-center">
                        <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 2009 }).toPath()}>
                          <a className="btn btn-primary md:tw-text-base tw-text-sm">
                            support Burm & Emily{"'"}s experience
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : badgeName === badgeKinds.litterFreeLeaveNoTrace ? (
              <div className="md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">LEAVE NO TRACE STEWARDS</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Rudy
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-px-10 tw-px-0">
                  <div className="md:tw-mb-0 tw-mb-4 tw-flex-1">
                    <div className="tw-relative md:tw-pb-4 tw-pb-0">
                      <div className="md:tw-pl-5 tw-pl-0">
                        <ImageWithFallback
                          src={LeaveNoTrace1Image}
                          alt=""
                          className={styles.missionStoryFirstImage}
                        />
                      </div>
                      <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-6 md:tw--left-2 tw--top-4 tw--left-3">
                        <ImageWithFallback
                          src={Badge2Image}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-absolute tw--left-28 tw--bottom-88 md:tw-block tw-hidden tw-w-full md:tw-pl-18 tw-pl-0">
                        <ImageWithFallback
                          src={LeaveNoTrace2Image}
                          alt=""
                          className={styles.missionStorySecondImage}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="md:tw-mb-0 tw-mb-4 tw-flex-1">
                    <div className="md:tw-pl-10 tw-pl-0">
                      <div className="tw-mb-6 tw-max-w-sm">
                        Rudy first started as a porter on Mount Rinjani, and saw how his beloved
                        mountain was polluted by trash. Eventually, he saved enough to start his own
                        guiding company.
                      </div>
                      <ImageWithFallback
                        src={MountainImage}
                        fill
                        alt=""
                        className="tw-static tw-block md:tw-hidden tw-block tw-object-cover tw-w-full tw-h-full tw-pb-2 tw-px-4"
                      />
                      <div className="tw-mb-6 tw-max-w-sm">
                        Determined to make a difference, he trained his guides in responsible
                        practices to address the mountain{"'"}s pollution. His team not only cleans
                        up their own waste but also that of other groups, which is pretty unheard
                        of!
                      </div>
                      <div className="tw-mb-6 tw-max-w-sm">
                        Responsible guides trained by Rudy, have gone on to establish their own
                        guiding companies, creating a network of eco-conscious businesses in
                        Rinjani.
                      </div>
                      <div className="tw-mb-6 tw-max-w-sm">
                        By choosing Rudy{"'"}s team, you{"'"}re not just getting an amazing climb,
                        you{"'"}re directly supporting a cleaner Rinjani and a more responsible
                        tourism industry there.
                      </div>
                      <div className="md:tw-hidden tw-block tw-mb-8">
                        <ImageWithFallback
                          src={LeaveNoTrace2Image}
                          alt=""
                          className={`${styles.missionStorySecondImage}`}
                        />
                      </div>
                      <div className="md:tw-text-left tw-text-center">
                        <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 216 }).toPath()}>
                          <a className="btn btn-primary md:tw-text-base tw-text-sm">
                            support Rudy’s experience
                          </a>
                        </Link>
                      </div>
                      <ImageWithFallback
                        src={MountainImage}
                        fill
                        alt=""
                        className="tw-static tw-block tw-object-cover tw-w-auto tw-h-52 md:tw-block tw-hidden tw-ml-16"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : badgeName === badgeKinds.lowCarbon ? (
              <div className="md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">LOW CARBON HEROES</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Wayan
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-10 tw-mb-4 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <div className="tw-flex-1 tw-relative md:tw-mb-0 tw-mb-4">
                    <div className="md:tw-pl-10 tw-pl-0">
                      <ImageWithFallback
                        src={LowCarbon1Image}
                        alt=""
                        className={styles.missionStoryFirstImage}
                      />
                    </div>
                    <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-14 md:tw-left-6 tw--top-4 tw--left-3">
                      <ImageWithFallback
                        src={Badge4Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                    <div className="tw-h-24 tw-w-20 tw-absolute tw-bottom-0 tw--right-8 md:tw-hidden tw-block">
                      <ImageWithFallback
                        src={Grass1Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                    <div className="tw-h-12 tw-w-12 tw-absolute tw-top-4 tw--left-8 md:tw-block tw-hidden">
                      <ImageWithFallback
                        src={Butterfly3Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                    <div className="tw-h-8 tw-w-7 tw-absolute tw--top-4 tw-right-10 md:tw-hidden tw-block">
                      <ImageWithFallback
                        src={Butterfly2Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-mb-6 tw-max-w-sm">
                      Wayan saw his beloved Bali threatened by the dimming lights of its fireflies.
                      These tiny creatures, indicators of a healthy ecosystem, were disappearing, a
                      warning sign of environmental imbalance.
                    </div>
                    <div className="tw-max-w-sm">
                      Driven by a passion for these enchanting insects and his vision for a
                      sustainable Bali, Wayan and his team partnered with local farmers to promote
                      pesticide-free farming, reduce carbon emissions and protect crucial
                      ecosystems.
                    </div>
                  </div>
                </div>
                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-pl-40 tw-pl-0">
                  <div className="tw-flex-1 tw-relative">
                    <ImageWithFallback
                      src={LowCarbon2Image}
                      alt=""
                      className={`${styles.missionStorySecondImage} md:tw-mb-0 tw-mb-4`}
                    />
                    <div className="tw-absolute md:tw-w-64 md:tw-h-96 md:tw--top-12 md:tw--left-60 tw-h-40 tw-w-28 tw-top-0 tw--left-5">
                      <ImageWithFallback src={Tree1Image} alt="" className="tw-w-full tw-h-full" />
                    </div>
                    <div className="tw-h-6 tw-w-6 tw-absolute tw--top-8 tw-right-0 md:tw-hidden tw-block">
                      <ImageWithFallback
                        src={Butterfly1Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-relative tw-max-w-xs tw-mb-8">
                      Choosing this experience isn{"'"}t just about witnessing firefly magic; it
                      {"'"}s about joining Wayan{"'"}s journey towards a low-carbon future. You
                      {"'"}ll be supporting sustainable agriculture, enjoying locally-sourced food,
                      and exploring nature on foot - all while contributing to a brighter, greener
                      Bali.
                      <div className="tw-absolute tw--bottom-8 tw--right-44 tw-w-44 tw-h-52 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Grass1Image}
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-h-12 tw-w-12 tw-absolute tw--top-14 tw--right-14 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Butterfly1Image}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-h-14 tw-w-11 tw-absolute tw--top-6 tw--right-36 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Butterfly2Image}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                    </div>

                    <div className="md:tw-text-left tw-text-center">
                      <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 1969 }).toPath()}>
                        <a className="btn btn-primary md:tw-text-base tw-text-sm">
                          support Wayan{"'"}s experience
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : badgeName === badgeKinds.refusePlastics ? (
              <div className="md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">PLASTIC WASTE WARRIORS</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Warren
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center tw-mb-10 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <div className="tw-flex-1 tw-relative md:tw-mb-0 tw-mb-4">
                    <div className="md:tw-pl-10 tw-pl-0">
                      <ImageWithFallback
                        src={RefusePlastics1Image}
                        alt=""
                        className={styles.missionStoryFirstImage}
                      />
                    </div>
                    <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-14 md:tw-left-6 tw--top-2 tw--left-3">
                      <ImageWithFallback
                        src={Badge3Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                    <div className="tw-absolute tw--top-4 tw-right-14 tw-w-14 tw-h-20">
                      <ImageWithFallback
                        src={Plastic1Image}
                        alt=""
                        className="tw-w-full tw-h-full md:tw-hidden tw-block"
                      />
                    </div>
                    <div className="tw-absolute tw-top-8 tw--right-4 tw-w-10 tw-h-20">
                      <ImageWithFallback
                        src={Plastic2Image}
                        alt=""
                        className="tw-w-full tw-h-full md:tw-hidden tw-block"
                      />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-mb-6 tw-max-w-sm">
                      Most people don{"'"}t know this, but stunning Komodo National Park has a
                      plastic waste problem. Not only does waste wash onto its islands{"'"}{' '}
                      shores from neighbouring islands, the increasing tourism makes it even more
                      difficult to dispose of all the waste.
                    </div>
                    <div className="tw-max-w-sm">
                      Local guide Warren, witnessing the damage firsthand, decided to take action.
                      He and his team incorporate daily trash pickups into their tours, ensuring
                      that every adventure contributes to the park{"'"}s preservation. Even during
                      the off-season, their commitment continues, with harbor cleanups taking
                      priority.
                    </div>
                  </div>
                </div>
                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-pl-40 tw-pl-0">
                  <div className="tw-flex-1 tw-relative">
                    <ImageWithFallback
                      src={RefusePlastics2Image}
                      alt=""
                      className={`${styles.missionStorySecondImage} md:tw-mb-0 tw-mb-4`}
                    />
                    <div className="tw-h-28 tw-w-24 md:tw-w-48 md:tw-h-56 tw-absolute md:tw-top-0 md:tw--left-40 tw--top-7 tw--left-3">
                      <ImageWithFallback
                        src={PlasticImage}
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-relative tw-max-w-xs tw-mb-8">
                      When you go on a Komodo trip with Warren, you{"'"}re not just experiencing
                      Komodo{"'"}s wonders; you{"'"}re directly supporting his team{"'"}s mission to
                      keep the islands clean.
                      <div className="tw-absolute tw--bottom-36 tw--right-28 tw-w-24 tw-h-32 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Plastic1Image}
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                      <div className="tw-absolute tw-bottom-2 tw--right-28 tw-w-16 tw-h-36 lg:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Plastic2Image}
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                    </div>

                    <div className="md:tw-text-left tw-text-center">
                      <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 659 }).toPath()}>
                        <a className="btn btn-primary md:tw-text-base tw-text-sm">
                          support Warren{"'"}s experience
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : badgeName === badgeKinds.communityBased ? (
              <div className="md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">COMMUNITY CHAMPIONS</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Nyoman and Wayan
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center tw-mb-10 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <div className="tw-flex-1 tw-relative md:tw-mb-0 tw-mb-4">
                    <div className="md:tw-pl-10 tw-pl-0">
                      <ImageWithFallback
                        src={CommunityBased1Image}
                        alt=""
                        className={styles.missionStoryFirstImage}
                      />
                    </div>
                    <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-14 md:tw-left-6 tw--top-2 tw--left-3">
                      <ImageWithFallback
                        src={Badge6Image}
                        fill
                        alt=""
                        className="tw-w-full tw-h-full"
                      />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-mb-6 tw-max-w-sm">
                      Nyoman and Wayan are a husband and wife team who founded their organic coffee
                      farm, Bali Beans, to share their love for Balinese coffee and promote fair
                      trade and sustainable farming in their community.
                    </div>
                    <div className="tw-max-w-sm">
                      For them, Bali Beans is more than just a business; it{"'"}s their way of
                      giving back. They ensure that the farmers who grow their exceptional coffee
                      beans are paid fairly and work in harmony with the land, using no pesticides
                      or luwak to protect Bali{"'"}s natural beauty.
                    </div>
                  </div>
                </div>
                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-pl-40 tw-pl-0">
                  <div className="tw-flex-1 tw-relative tw-mb-8">
                    <ImageWithFallback
                      src={CommunityBased2Image}
                      alt=""
                      className={styles.missionStorySecondImage}
                    />
                    <div className="tw-h-28 tw-w-24 md:tw-w-48 md:tw-h-60 tw-absolute md:tw-top-10 md:tw--left-40 tw--bottom-5 tw--left-6">
                      <ImageWithFallback src={Tree2Image} alt="" className="tw-w-full tw-h-full" />
                    </div>
                    <div className="tw-absolute tw--top-8 tw--right-2 tw-w-15 tw-h-24 md:tw-hidden tw-block">
                      <ImageWithFallback src={CafeImage} alt="" className="tw-w-full tw-h-full" />
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-pl-10 tw-pl-0">
                    <div className="tw-relative tw-max-w-xs tw-mb-8">
                      By choosing their experience, you{"'"}re not just enjoying delicious coffee;
                      you{"'"}re supporting a movement to empower farmers and restore the community
                      {"'"}s land.
                      <div className="tw-absolute tw--top-16 tw--right-28 tw-w-24 tw-h-32 lg:tw-block tw-hidden">
                        <ImageWithFallback src={CafeImage} alt="" className="tw-w-full tw-h-full" />
                      </div>
                    </div>

                    <div className="md:tw-text-left tw-text-center">
                      <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 1702 }).toPath()}>
                        <a className="btn btn-primary md:tw-text-base tw-text-sm">
                          support Nyoman and Wayan{"'"}s experience
                        </a>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : badgeName === badgeKinds.womenOwned ? (
              <div className="container md:tw-py-16 tw-py-8">
                <div className="tw-text-center tw-mb-12">
                  <div className="tw-text-xs tw-font-semibold tw-mb-6">WOMEN-LED WONDERS</div>
                  <div className="md:tw-text-6xl tw-text-5xl tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none">
                    Katni
                  </div>
                </div>

                <div className="md:tw-flex tw-flex-row tw-justify-center md:tw-mb-24 tw-mb-16 tw-max-w-xs md:tw-max-w-5xl tw-mx-auto md:tw-px-10 tw-px-0">
                  <div className="tw-flex-1 tw-mb-6">
                    <div className="tw-relative md:tw-mb-10 tw-mb-0 md:tw-px-2 tw-px-0">
                      <ImageWithFallback
                        src={WomenOwned1Image}
                        alt=""
                        className={styles.missionStoryFirstImage}
                      />
                      <div className="md:tw-w-20 md:tw-h-20 tw-h-16 tw-w-16 tw-absolute md:tw--top-12 md:tw--left-6 tw--top-10 tw--left-3">
                        <ImageWithFallback
                          src={Badge5Image}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                    </div>
                    <div className="tw-relative tw-px-10 md:tw-block tw-hidden">
                      <ImageWithFallback
                        src={WomenOwned2Image}
                        alt="Burm Emily Image"
                        className={styles.missionStorySecondImage}
                      />
                      <div className="tw-absolute tw-w-36 tw-h-72 tw--bottom-2 tw--left-20">
                        <ImageWithFallback
                          src={BirdImage}
                          fill
                          alt=""
                          className="tw-w-full tw-h-full"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="tw-flex-1 md:tw-mb-0 tw-mb-4">
                    <div className="tw-relative md:tw-pl-10 tw-pl-0">
                      <div className="tw-absolute tw--top-6 tw--left-10 tw-w-96 md:tw-block tw-hidden">
                        <ImageWithFallback
                          src={Mountain1Image}
                          alt="Burm Emily"
                          className="tw-static tw-block tw-object-cover tw-w-full tw-h-auto"
                        />
                      </div>
                      <div className="md:tw-w-96 tw-w-full md:tw-pt-48 tw-pt-0 tw-pb-6">
                        Katni is a force of nature. She is the very first woman guide in Lombok.
                      </div>
                      <div className="tw-mb-4 tw-max-w-sm">
                        When she first started guiding in Lombok, it was taboo for women to lead
                        hikes in the deeply patriarchal society of Lombok. So she started her own
                        guiding business (still the only female-owned business in Rinjani!), and
                        hired women as guides.
                      </div>
                      <ImageWithFallback
                        src={Mountain1Image}
                        alt="Burm Emily"
                        className="tw-static tw-block tw-object-cover tw-w-full tw-h-auto md:tw-hidden tw-block"
                      />
                      <ImageWithFallback
                        src={WomenOwned2Image}
                        alt="Burm Emily"
                        className={`${styles.missionStorySecondImage} md:tw-hidden tw-block tw-mb-6`}
                      />
                      <div className="tw-mb-6 tw-max-w-sm">
                        Through her work, she{"'"}s single handedly shattered taboos in Lombok,
                        changed mindsets of men and women in Lombok, and have given women
                        opportunities to earn an income.
                      </div>
                      <div className="tw-mb-6 tw-max-w-sm">
                        When you go on a trek with Katni{"'"}s team of kick-ass female guides, you
                        {"'"}re contributing to a more equal society.
                      </div>
                      <div className="md:tw-text-left tw-text-center">
                        <Link legacyBehavior prefetch={false} href={AppRoutes.operatorRoute({ id: 1915 }).toPath()}>
                          <a className="btn btn-primary md:tw-text-base tw-text-sm">
                            support Katni{"'"}s experience
                          </a>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const Page = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const bottomBadgesRef = useRef<HTMLDivElement | null>(null);
  const [showStoryPopup, setShowStoryPopup] = useState(false);
  const [showBadgeTooltip, setShowBadgeTooltip] = useState(false);
  const [badgeName, setBadgeName] = useState<string | undefined>(undefined);
  const badgeRef = useRef<HTMLElement | null>(null);
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const [overlayTopPosition, setOverlayTopPosition] = useState(false);

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const target = event.target;
      if (!containerRef.current || !(target instanceof HTMLElement)) return;
      if (containerRef.current.contains(target)) {
        if (Object.values(badgeKinds).some((v) => v === (target.dataset['badge'] as string))) {
          badgeRef.current = target;
          setBadgeName(target.dataset['badge']);
          setShowBadgeTooltip(true);
          setOverlayTopPosition(
            bottomBadgesRef.current && bottomBadgesRef.current.contains(target) ? true : false
          );
        } else {
          setShowBadgeTooltip(false);
        }
      }
    };

    document.addEventListener('mousemove', listener);
    document.addEventListener('scroll', () => {
      setShowBadgeTooltip(false);
    });

    return () => {
      document.removeEventListener('mousemove', listener);
      document.removeEventListener('scroll', () => {
        setShowBadgeTooltip(false);
      });
    };
  }, []);
  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDesc}
        canonical={AppRoutes.ourMissionRoute().toUrl()}
        openGraph={{
          url: AppRoutes.ourMissionRoute().toUrl(),
          title: metaTitle,
          description: metaDesc,
        }}
      />
      <WithDefaultJsonLd />

      <div className="tw-relative">
        <div className="tw-bg-brand-green">
          <div className="container tw-max-w-5xl md:tw-py-24 tw-py-16">
            <div className="tw-max-w-md md:tw-max-w-5xl tw-mx-auto">
              <div className="tw-text-center tw-mb-16 md:tw-text-8xl tw-text-6xl tw-font-styleSans tw-font-semibold">
                Travel as a <br />
                force for good
              </div>
              <div className="md:tw-flex tw-flex-row tw-justify-center tw-items-center">
                <div className="tw-flex-1 md:tw-mr-16 tw-mr-0 md:tw-mb-0 tw-mb-8">
                  <ImageWithFallback
                    src={SustainabilityImage}
                    fill
                    alt=""
                    className="tw-static tw-block tw-object-cover tw-w-full tw-h-auto"
                  />
                </div>
                <div className="tw-flex-1 tw-text-center md:tw-text-lg">
                  <div className="tw-max-w-sm">
                    <div className="tw-mb-4">
                      At Seek Sophie, we believe that how we travel can change the world. Every
                      choice we make, from the guide we hike with to the hotel we stay in, has an
                      impact. That’s why we work with local guides who actively make a difference in
                      their communities and environment.
                    </div>
                    <div>
                      When you choose a Seek Sophie experience, you’re not just a tourist passing
                      through – you{"'"}re making a real difference in the lives of the people you
                      meet and the places you explore.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ref={containerRef} className="tw-bg-brand-yellow">
          <div className="container tw-max-w-5xl tw-py-16 md:tw-py-24 tw-text-center">
            <div className="md:tw-mb-24 tw-mb-16">
              <div className="tw-font-semibold tw-text-6xl md:tw-text-8xl tw-leading-none md:tw-leading-none tw-z-10 tw-font-styleSans md:tw-max-w-6xl tw-px-8 tw-text-center tw-mx-auto">
                The people <br />
                we support
              </div>
            </div>

            <div className="row row-original md:tw-mb-32 tw-mb-16">
              <div className="col-md-6 tw-order-1 md:tw-mb-0 tw-mb-4 tw-p-0">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Wildlife <br /> Protectors
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={WildlifeSafeImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw-bottom-0 md:tw-right-14 tw-right-10">
                    <ImageWithFallback
                      src={Badge1Image}
                      alt=""
                      data-badge={badgeKinds.wildlifeSafe}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw-top-0 tw--right-5">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-5 tw-h-5" />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-2 tw-right-0"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.wildlifeSafe);
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6 tw-order-2 md:tw-pl-20 tw-pl-0">
                <div className="tw-relative">
                  <div className="tw-absolute tw-top-0 md:tw--left-10 lg:tw-left-4 tw-w-20 tw-top-2 md:tw-block tw-hidden">
                    <ImageWithFallback
                      src={Badge1Image}
                      alt=""
                      data-badge={badgeKinds.wildlifeSafe}
                      className="tw-h-20 tw-w-auto tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--right-2 tw--top-6">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-7 tw-h-7" />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none tw-mb-6 md:tw-block tw-hidden">
                    Wildlife
                    <br /> Protectors
                  </div>
                  <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                    Emily and her partner Burm, founded one of Thailand{"'"}s first truly{' '}
                    <span
                      onClick={() => {
                        setShowStoryPopup(true);
                        setBadgeName(badgeKinds.wildlifeSafe);
                      }}
                      className={`${styles.highlightText} tw-cursor-pointer`}
                    >
                      ethical no-touch, no-bathe
                    </span>{' '}
                    sanctuaries where elephants are free to be their wildest selves.
                  </div>
                </div>
              </div>
            </div>

            <div className="row row-original md:tw-mb-32 tw-mb-16">
              <div className="col-md-6 tw-order-2 md:tw-mb-0 tw-mb-4">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Leave No Trace
                  <br /> Stewards
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={LeaveNoTraceImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw-bottom-0 tw-right-4 tw--bottom-4">
                    <ImageWithFallback
                      src={Badge2Image}
                      alt=""
                      data-badge={badgeKinds.litterFreeLeaveNoTrace}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw--top-3 tw--right-3">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-5 tw-h-5" />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-1 md:tw-left-16 tw-left-10"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.litterFreeLeaveNoTrace);
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6 md:tw-order-1 tw-order-2 md:tw-pr-18">
                <div className="tw-relative tw-mb-6 tw-hidden md:tw-block">
                  <div className="tw-absolute tw-top-0 tw--right-10 lg:tw--right-7 tw-w-20 tw-top-2">
                    <ImageWithFallback
                      src={Badge2Image}
                      alt="Wildlife Protectors"
                      data-badge={badgeKinds.litterFreeLeaveNoTrace}
                      className="tw-w-20 tw-h-20 tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--right-2 tw--top-6">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-7 tw-h-7" />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none">
                    Leave No Trace
                    <br /> Stewards
                  </div>
                </div>
                <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                  Rudy first started as a porter on Mount Rinjani, and saw how his beloved mountain
                  was polluted by trash. Determined to make a difference, he trained his guides in{' '}
                  <span
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.litterFreeLeaveNoTrace);
                    }}
                    className={`${styles.highlightText} tw-cursor-pointer`}
                  >
                    responsible practices
                  </span>{' '}
                  to Leave No Trace.
                </div>
              </div>
            </div>

            <div className="row row-original md:tw-mb-32 tw-mb-16">
              <div className="col-md-6 tw-order-1 md:tw-mb-0 tw-mb-4 tw-p-0">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Low Carbon
                  <br /> Heroes
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={LowCarbonImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw--bottom-4 tw-right-4">
                    <ImageWithFallback
                      src={Badge4Image}
                      alt=""
                      data-badge={badgeKinds.lowCarbon}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw--top-3 tw--right-3">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-5 tw-h-5" />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-2 tw-right-0"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.lowCarbon);
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6 tw-order-2 md:tw-pl-16">
                <div className="tw-relative tw-mb-6 tw-hidden md:tw-block">
                  <div className="tw-absolute tw-top-0 tw--right-4 lg:tw--right-2 tw-w-20 tw-top-2">
                    <ImageWithFallback
                      src={Badge4Image}
                      alt="Low Carbon Heroes"
                      data-badge={badgeKinds.lowCarbon}
                      className="tw-w-20 tw-h-20 tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--right-2 tw--top-6">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-7 tw-h-7" />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none">
                    Low Carbon
                    <br /> Heroes
                  </div>
                </div>
                <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                  Driven by a passion for fireflies and his vision for a sustainable Bali, Wayan and
                  his team partners with local farmers to promote pesticide-free farming,{' '}
                  <span
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.lowCarbon);
                    }}
                    className={`${styles.highlightText} tw-cursor-pointer`}
                  >
                    reduce carbon emissions
                  </span>{' '}
                  and protect crucial ecosystems.
                </div>
              </div>
            </div>

            <div className="row row-original md:tw-mb-32 tw-mb-16">
              <div className="col-md-6 tw-order-2 md:tw-mb-0 tw-mb-4">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Plastic Waste
                  <br /> Warriors
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={RefusePlasticsImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw-left-12 tw--bottom-2">
                    <ImageWithFallback
                      src={Badge3Image}
                      alt=""
                      data-badge={badgeKinds.refusePlastics}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw--left-5 tw-bottom-1">
                      <ImageWithFallback
                        src={BadgeEfftectImage}
                        alt=""
                        className="tw-w-5 tw-h-5 tw-transform tw--rotate-180"
                      />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-2 tw-left-10"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.refusePlastics);
                    }}
                  ></div>
                </div>
              </div>

              <div className="col-md-6 md:tw-order-1 tw-order-2 md:tw-pr-18">
                <div className="tw-relative tw-mb-6 tw-hidden md:tw-block">
                  <div className="tw-absolute tw-top-0 tw--right-10 lg:tw--right-7 tw-w-20 tw-top-2">
                    <ImageWithFallback
                      src={Badge3Image}
                      alt="Plastic Waste Warriors"
                      data-badge={badgeKinds.refusePlastics}
                      className="tw-w-20 tw-h-20 tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--right-2 tw--top-6">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-7 tw-h-7" />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none">
                    Plastic Waste
                    <br /> Warriors
                  </div>
                </div>
                <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                  Witnessing the damage plastic waste was making to Komodo National Park, local
                  guide Warren and his team incorporate{' '}
                  <span
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.refusePlastics);
                    }}
                    className={`${styles.highlightText} tw-cursor-pointer`}
                  >
                    daily trash pickups
                  </span>{' '}
                  into their tours, ensuring that every adventure contributes to the park{"'"}s
                  preservation.
                </div>
              </div>
            </div>

            <div className="row row-original md:tw-mb-32 tw-mb-16">
              <div className="col-md-6 tw-order-1 md:tw-mb-0 tw-mb-4 tw-p-0">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Community
                  <br /> Champions
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={CommunityBasedImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw-bottom-1 tw-left-8">
                    <ImageWithFallback
                      src={Badge6Image}
                      alt=""
                      data-badge={badgeKinds.communityBased}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw--left-4 tw--bottom-1">
                      <ImageWithFallback
                        src={BadgeEfftectImage}
                        alt=""
                        className="tw-w-5 tw-h-5 tw-transform tw--rotate-180"
                      />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-0 md:tw-left-32 tw-left-20"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.communityBased);
                    }}
                  ></div>
                </div>
              </div>

              <div className="col-md-6 tw-order-2 md:tw-pl-16">
                <div className="tw-relative tw-mb-6 tw-hidden md:tw-block">
                  <div className="tw-absolute tw-top-0 tw--left-10 lg:tw--left-7 tw-w-20 tw-top-2">
                    <ImageWithFallback
                      src={Badge6Image}
                      alt="Community Champions"
                      data-badge={badgeKinds.communityBased}
                      className="tw-w-20 tw-h-20 tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--left-6 tw--top-4">
                      <ImageWithFallback
                        src={BadgeEfftectImage}
                        alt=""
                        className="tw-w-7 tw-h-7 tw-transform tw--rotate-90"
                      />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none">
                    Community
                    <br /> Champions
                  </div>
                </div>
                <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                  Nyoman and Wayan are husband and wife who founded their organic coffee farm, Bali
                  Beans, to share their love for Balinese coffee and{' '}
                  <span
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.communityBased);
                    }}
                    className={`${styles.highlightText} tw-cursor-pointer`}
                  >
                    promote fair trade
                  </span>{' '}
                  and sustainable farming in their community.
                </div>
              </div>
            </div>

            <div className="row row-original md:tw-mb-24 tw-mb-16 tw-max-w-sm md:tw-max-w-5xl tw-mx-auto">
              <div className="col-md-6 tw-order-2 md:tw-mb-0 tw-mb-4">
                <div className="tw-text-5xl tw-mb-6 tw-font-styleSans tw-font-semibold tw-leading-none md:tw-hidden tw-block">
                  Women-led
                  <br /> Wonders
                </div>
                <div className="tw-relative tw-max-w-xs md:tw-max-w-5xl tw-mx-auto">
                  <ImageWithFallback
                    src={WomenOwnedImage}
                    alt=""
                    className="tw-h-auto tw-w-full tw-static tw-block tw-object-contain"
                  />
                  <div className="tw-absolute md:tw-hidden tw-w-14 tw-h-14 tw--bottom-2 tw-left-11">
                    <ImageWithFallback
                      src={Badge5Image}
                      alt=""
                      data-badge={badgeKinds.womenOwned}
                      className="tw-w-full tw-h-full"
                    />
                    <div className="tw-absolute tw--left-4 tw--bottom-0">
                      <ImageWithFallback
                        src={BadgeEfftectImage}
                        alt=""
                        className="tw-w-5 tw-h-5 tw-transform tw--rotate-180"
                      />
                    </div>
                  </div>
                  <div
                    className="tw-absolute md:tw-w-32 md:tw-h-20 tw-w-24 tw-h-10 tw-cursor-pointer tw-top-2 tw-right-5"
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.womenOwned);
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6 md:tw-order-1 tw-order-2 md:tw-pr-18">
                <div className="tw-relative tw-mb-6 tw-hidden md:tw-block">
                  <div className="tw-absolute tw-top-0 tw--right-10 lg:tw--right-7 tw-w-20 tw-top-2">
                    <ImageWithFallback
                      src={Badge5Image}
                      alt="Women-led Wonders"
                      data-badge={badgeKinds.womenOwned}
                      className="tw-w-20 tw-h-20 tw-cursor-pointer"
                    />

                    <div className="tw-absolute tw--right-2 tw--top-6">
                      <ImageWithFallback src={BadgeEfftectImage} alt="" className="tw-w-7 tw-h-7" />
                    </div>
                  </div>
                  <div className="md:tw-text-6xl tw-font-styleSans tw-font-semibold tw-leading-none">
                    Women-led
                    <br /> Wonders
                  </div>
                </div>
                <div className="md:tw-text-4xl tw-text-xl tw-max-w-sm tw-m-auto tw-font-styleSans tw-font-semibold tw-leading-none md:tw-leading-none md:tw-px-0 tw-px-4">
                  As the very{' '}
                  <span
                    onClick={() => {
                      setShowStoryPopup(true);
                      setBadgeName(badgeKinds.womenOwned);
                    }}
                    className={`${styles.highlightText} tw-cursor-pointer`}
                  >
                    first female guide
                  </span>{' '}
                  in Lombok who started her own guiding business that employs other women, Katni has
                  single handedly shattered taboos in Lombok, changed mindsets of men and women in
                  Lombok, and have given women opportunities to earn an income.
                </div>
              </div>
            </div>
          </div>

          <div ref={bottomBadgesRef} className="tw-bg-white">
            <div className="container tw-max-w-3xl tw-py-16 md:tw-py-24 tw-text-center">
              <div className="tw-max-w-sm md:tw-max-w-3xl tw-mx-auto">
                <div className="tw-px-15 md:tw-text-6xl tw-text-5xl tw-mb-2 tw-font-styleSans tw-font-semibold tw-leading-none">
                  Small actions, large impact
                </div>
                <div className="md:tw-px-32 tw-px-0 tw-mb-12">
                  Each time you book an experience with these badges, you get to support these
                  businesses and make a difference!
                </div>
                <div className="md:tw-flex tw-flex-row">
                  <div className="md:tw-mb-0">
                    <div className="tw-mb-6 tw-font-styleSans tw-font-semibold tw-text-2xl">
                      Environmental
                    </div>
                    <div className="tw-grid tw-gap-4 tw-px-15 md:tw-px-0 tw-grid-cols-2 md:tw-grid-cols-4">
                      <div className="">
                        <ImageWithFallback
                          src={Badge1Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.wildlifeSafe}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Wildlife
                          <br /> Protector
                        </div>
                      </div>
                      <div className="">
                        <ImageWithFallback
                          src={Badge2Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.litterFreeLeaveNoTrace}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Leave No Trace <br />
                          Steward
                        </div>
                      </div>
                      <div className="">
                        <ImageWithFallback
                          src={Badge4Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.lowCarbon}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Low Carbon <br />
                          Guardian
                        </div>
                      </div>
                      <div>
                        <ImageWithFallback
                          src={Badge3Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.refusePlastics}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Plastic Waste <br />
                          Warrior
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:tw-border-l tw-border-t tw-border-grey-lighter md:tw-mx-12 md:tw-my-0 tw-my-8"></div>
                  <div>
                    <div className="tw-mb-6 tw-font-styleSans tw-font-semibold tw-text-2xl">
                      Social
                    </div>
                    <div className="tw-grid tw-gap-4 tw-px-15 md:tw-px-0 tw-grid-cols-2">
                      <div className="">
                        <ImageWithFallback
                          src={Badge5Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.womenOwned}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Women-led <br />
                          Wonder
                        </div>
                      </div>
                      <div>
                        <ImageWithFallback
                          src={Badge6Image}
                          fill
                          alt=""
                          data-badge={badgeKinds.communityBased}
                          className="tw-static tw-block tw-object-contain tw-w-full tw-h-16"
                        />
                        <div className="tw-text-sm tw-font-semibold">
                          Community <br />
                          Champion
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <StoryPopup
        badgeName={badgeName}
        isShow={showStoryPopup}
        onClose={() => {
          setShowStoryPopup(false);
          setBadgeName(undefined);
        }}
      />

      <div>
        <Overlay
          popperConfig={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 0],
                },
              },
            ],
          }}
          placement={overlayTopPosition ? 'top' : 'bottom'}
          target={badgeRef.current}
          show={showBadgeTooltip}
        >
          {({ placement, arrowProps, show: _show, popper, ...props }) => (
            <div
              {...props}
              ref={(e) => {
                props.ref(e);
                overlayRef.current = e;
              }}
              style={props.style}
              className={classNames('tw-z-1200 tw-m-0 tw-max-w-lg md:tw-block tw-hidden', {
                'tw-pb-2.5': overlayTopPosition,
                'tw-pt-2.5': !overlayTopPosition,
              })}
              onMouseEnter={() => setShowBadgeTooltip(true)}
              onMouseLeave={() => setShowBadgeTooltip(false)}
            >
              <BadgeTipDescription badgeName={badgeName} />
            </div>
          )}
        </Overlay>
      </div>

      <div>
        <div
          className={classNames(
            'md:tw-hidden tw-block tw-flex tw-justify-center tw-fixed tw-left-1/2 tw-top-1/2 tw-transform tw--translate-y-1/2 tw--translate-x-1/2 tw-w-screen tw-z-1300 tw-max-w-sm',
            {
              'tw-hidden': !showBadgeTooltip,
            }
          )}
        >
          <div className="tw-bg-brand-green tw-h-auto tw-mx-6 tw-rounded-lg md:tw-w-lg tw-z-1300">
            <div className="tw-text-center tw-relative">
              <BadgeTipDescription badgeName={badgeName} />
              <div
                className="tw-absolute tw-right-6 tw-top-6"
                onClick={() => {
                  setShowBadgeTooltip(false);
                }}
              >
                <FiX size={20} className="tw-text-brand-navy" />
              </div>
            </div>
          </div>
        </div>
        <ClientOnlyPortal selector="#bottom-body">
          <div
            className={classNames(
              'tw-bg-black tw-bottom-0 tw-left-0 tw-opacity-30 tw-fixed tw-h-full tw-z-1200 tw-w-screen md:tw-hidden tw-block',
              { 'tw-hidden': !showBadgeTooltip }
            )}
          ></div>
        </ClientOnlyPortal>
      </div>
    </>
  );
};

export default Page;
